var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.recipesLoaded)?_c('div',[_c('RecipeView',{attrs:{"recipe":_vm.recipe}})],1):_c('div',[_c('p',[_vm._v("Loading...")])])}
var staticRenderFns = []

export { render, staticRenderFns }